import React from 'react';

//import Image from 'react-bootstrap/Image';
import "./styles/rfps.css";
import ContentWrapper from '../contentWrapper/ContentWrapper';


function Bid() {
    return (
        <ContentWrapper header="Request for Proposals (RFP)">
            <div className="rfps">
                <p>
                <a href="./rfp_north_doors.docx">Replacement/Restoration of North Double Door — Historic Vernon School</a>
                </p>
            </div>
        </ContentWrapper>
    );
}

export default Bid;